<template>
  <div class="user">
    <img :src="imgObj.defaultAvatar" alt="头像" class="avatar" />
    <img :src="imgObj.headDecoration" alt="头像装饰" class="head-decoration" />
    <div class="user-info">
      <p class="user-info-name">
        {{ userInfo.name }}
      </p>
      <div class="user-info-age">{{ userInfo.matchGroup | formatGroup }}{{ userInfo.province }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: {
    userInfo: {
      type: Object,
      default() {
        return {
          name: '',
          matchGroup: 0,
          province: ''
        }
      }
    }
  },
  data() {
    return {
      imgObj: {
        defaultAvatar: require('paintingCompetition/assets/personalHomepage/default_avatar.png'), // 默认头像
        headDecoration: require('paintingCompetition/assets/personalHomepage/head_decoration.png') // 头像装饰
      }
    }
  },
  filters: {
    formatGroup(data) {
      if (!data) return ''
      if (data === 1) return '幼儿组 - '
      if (data === 2) return '少儿组 - '
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
* {
  margin: 0;
  padding: 0;
}
.user {
  width: 370px;
  height: 180px;
  position: absolute;
  left: 30px;
  top: 20px;
  z-index: 10;

  .avatar {
    width: 120px;
    height: 120px;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .head-decoration {
    width: 109px;
    height: 99px;
    position: absolute;
    top: 0;
    left: 80px;
  }

  &-info {
    width: 220px;
    height: 100px;
    color: #fff;
    position: absolute;
    left: 150px;
    bottom: 0;

    &-name {
      font-family: HYZHENGYUAN-75W;
      font-weight: 600;
      font-size: 38px;
      @include text-ellipsis;
    }

    &-age {
      font-family: HYZHENGYUAN-55W;
      font-weight: 400;
      font-size: 28px;
      @include text-ellipsis;
    }
  }
}
</style>
